import type { BezierSegment, SpeedSegment, SplineBlob } from './animationPaths'

export interface DebugSplinePath {
  segments: BezierSegment[]
  windowStart?: number
  totalLength: number
}

export interface DebugSpeedSpline {
  segments: SpeedSegment[]
  windowStart?: number
  totalLength: number
}

export interface AnimatedBackgroundDebugData {
  blobs: SplineBlob[]
  splinePaths: Map<string, DebugSplinePath>
  speedSplines: Map<string, DebugSpeedSpline>
  blobPositions: Map<string, { x: number; y: number }> // Pre-calculated actual positions
  dimensions: { width: number; height: number }
  version: 'webgl' | 'canvas' | 'static'
}

// Global debug state for sharing data between components
class AnimatedBackgroundDebugState {
  private data: AnimatedBackgroundDebugData | null = null
  private listeners: Set<(data: AnimatedBackgroundDebugData | null) => void> = new Set()

  updateData(data: AnimatedBackgroundDebugData | null) {
    this.data = data
    this.listeners.forEach((listener) => listener(data))
  }

  getData(): AnimatedBackgroundDebugData | null {
    return this.data
  }

  subscribe(listener: (data: AnimatedBackgroundDebugData | null) => void): () => void {
    this.listeners.add(listener)
    return () => {
      this.listeners.delete(listener)
    }
  }
}

export const animatedBackgroundDebugState = new AnimatedBackgroundDebugState()
